import { combineReducers, applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit'
import { loginUserReducer } from './app/redux/reducers/user_reducer';
import dashboard_slice from './app/redux/reducers/dashboard_slice';
import generate_tickets_slice from './app/redux/reducers/generate_tickets_slice';
// import dashboard_slice from './app/redux/reducers/dashboard_slice';



let user = localStorage.getItem("user");

if(user){
  user=JSON.parse(user)
}



const initialState = {
  loginUser: {
    user: user || undefined
  }
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = configureStore({
  reducer: {
    // Define a top-level state field named `todos`, handled by `todosReducer`
    loginUser: loginUserReducer,
    dashboardModule: dashboard_slice,
    generateTickets:generate_tickets_slice

  },
  preloadedState: initialState
},
)

// const store = createStore(
//   reducer,
//   initialState,
//   composeEnhancer(applyMiddleware(thunk))
// );
export default store;

